import { useTranslation } from 'react-i18next';

const fallbackWatch = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400'%3E%3Crect width='400' height='400' fill='%23e8ddd0'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='22' fill='%237a6a5a'%3EWatch%3C/text%3E%3C/svg%3E";
const fallbackCoat = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='500'%3E%3Crect width='400' height='500' fill='%23ddd5c7'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='22' fill='%237a6a5a'%3ECoat%3C/text%3E%3C/svg%3E";
const fallbackFashion = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='500' height='650'%3E%3Crect width='500' height='650' fill='%23e0d8cc'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='26' fill='%237a6a5a'%3EFashion%3C/text%3E%3C/svg%3E";
const fallbackShoes = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='500'%3E%3Crect width='400' height='500' fill='%23d9cfc0'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='22' fill='%237a6a5a'%3EShoes%3C/text%3E%3C/svg%3E";
const fallbackPerfume = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400'%3E%3Crect width='400' height='400' fill='%23d4ccc0'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='22' fill='%237a6a5a'%3EPerfume%3C/text%3E%3C/svg%3E";
const fallbackHat = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300'%3E%3Crect width='300' height='300' fill='%23e5ddd2'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='18' fill='%237a6a5a'%3EHat%3C/text%3E%3C/svg%3E";
const fallbackBelt = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300'%3E%3Crect width='300' height='300' fill='%23e2d9cc'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='18' fill='%237a6a5a'%3EBelt%3C/text%3E%3C/svg%3E";
const fallbackTee = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300'%3E%3Crect width='300' height='300' fill='%23eae3d8'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='18' fill='%237a6a5a'%3ET-Shirt%3C/text%3E%3C/svg%3E";
const fallbackBag = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300'%3E%3Crect width='300' height='300' fill='%23ddd4c5'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='18' fill='%237a6a5a'%3EBag%3C/text%3E%3C/svg%3E";
const fallbackGlasses = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300'%3E%3Crect width='300' height='300' fill='%23e8e0d5'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='18' fill='%237a6a5a'%3EGlasses%3C/text%3E%3C/svg%3E";

export default function TrustSection() {
  const { t } = useTranslation();

  const guideCards = [
    {
      icon: 'ri-search-line',
      title: t('trust.guide1_title'),
      desc: t('trust.guide1_desc'),
      color: 'bg-primary-100 text-primary-700',
    },
    {
      icon: 'ri-shield-check-line',
      title: t('trust.guide2_title'),
      desc: t('trust.guide2_desc'),
      color: 'bg-accent-100 text-accent-700',
    },
    {
      icon: 'ri-truck-line',
      title: t('trust.guide3_title'),
      desc: t('trust.guide3_desc'),
      color: 'bg-secondary-100 text-secondary-700',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-[40%]">
            <span className="inline-block px-3 py-1 rounded-full border border-background-300/60 text-xs text-foreground-500 font-medium">
              {t('trust.label')}
            </span>
            <h2 className="mt-5 font-heading text-2xl md:text-4xl font-extrabold text-foreground-950 leading-tight">
              {t('trust.title_line1')}
              <br />
              <span className="text-accent-600 font-semibold">{t('trust.title_line2')}</span>
            </h2>
            <p className="mt-8 text-sm md:text-base text-foreground-600 leading-relaxed">
              {t('trust.description')}
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap underline underline-offset-4"
            >
              {t('trust.link_text')}
            </a>

            <div className="mt-10 grid grid-cols-1 gap-4">
              {guideCards.map((card, i) => (
                <div
                  key={i}
                  className="flex items-start gap-3 p-4 rounded-xl bg-background-100 border border-background-200/50 hover:border-primary-200/50 transition-colors"
                >
                  <span className={`w-9 h-9 flex items-center justify-center rounded-lg ${card.color} shrink-0`}>
                    <i className={`${card.icon} text-sm`}></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-bold text-foreground-900">{card.title}</h4>
                    <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-[60%] flex flex-col gap-6">
            <div className="flex gap-12 md:gap-16 justify-end">
              <div className="text-right">
                <span className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-950">
                  {t('trust.stat1_value')}
                </span>
                <p className="mt-1 text-xs md:text-sm text-foreground-500">{t('trust.stat1_label')}</p>
              </div>
              <div className="text-right">
                <span className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-950">
                  {t('trust.stat2_value')}
                </span>
                <p className="mt-1 text-xs md:text-sm text-foreground-500">{t('trust.stat2_label')}</p>
              </div>
            </div>

            <div className="relative h-[360px] md:h-[420px] mt-2">
              <div className="absolute top-0 left-4 w-28 h-28 md:w-36 md:h-36 rounded-2xl overflow-hidden bg-background-100 border border-background-200/50 z-10 rotate-[-8deg] shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20minimal%20watch%20and%20leather%20bracelet%20on%20cream%20background%20soft%20natural%20light%20editorial%20product%20photography%20warm%20gentle%20shadows%20premium%20accessory%20aesthetic%20no%20text%20no%20logos%20clean%20fresh%20look%20European%20style%20high%20detail%20minimalist%20composition&width=400&height=400&seq=trust-gallery-watch-v3&orientation=squarish"
                  alt="Premium accessories"
                  className="w-full h-full object-cover object-top"
                  onError={(e) => { (e.target as HTMLImageElement).src = fallbackWatch; }}
                />
              </div>

              <div className="absolute top-2 right-0 w-36 h-44 md:w-44 md:h-52 rounded-2xl overflow-hidden bg-background-100 border border-background-200/50 z-20 rotate-[5deg] shadow-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylish%20camel%20wool%20overcoat%20on%20hanger%20against%20cream%20wall%20soft%20natural%20daylight%20editorial%20fashion%20photography%20warm%20gentle%20shadows%20premium%20outerwear%20aesthetic%20no%20text%20no%20logos%20clean%20fresh%20look%20European%20style%20high%20detail%20fabric%20texture%20minimalist%20setting&width=400&height=500&seq=trust-gallery-jacket-v3&orientation=portrait"
                  alt="Premium wool coat"
                  className="w-full h-full object-cover object-top"
                  onError={(e) => { (e.target as HTMLImageElement).src = fallbackCoat; }}
                />
              </div>

              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-40 h-52 md:w-52 md:h-64 rounded-2xl overflow-hidden bg-background-100 border border-background-200/50 z-30 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Beautiful%20fashion%20items%20flat%20lay%20with%20clothing%20accessories%20and%20shoes%20on%20cream%20textured%20surface%20soft%20natural%20daylight%20editorial%20photography%20warm%20gentle%20shadows%20elegant%20composition%20no%20text%20no%20logos%20clean%20and%20fresh%20look%20European%20aesthetic%20high%20detail%20minimalist%20product%20photography&width=500&height=650&seq=trust-gallery-flatlay-v3&orientation=portrait"
                  alt="Fashion items flat lay"
                  className="w-full h-full object-cover object-top"
                  onError={(e) => { (e.target as HTMLImageElement).src = fallbackFashion; }}
                />
              </div>

              <div className="absolute bottom-0 left-0 w-32 h-40 md:w-40 md:h-48 rounded-2xl overflow-hidden bg-background-100 border border-background-200/50 z-10 rotate-[6deg] shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=Premium%20navy%20blue%20suede%20loafers%20on%20marble%20surface%20soft%20natural%20daylight%20editorial%20product%20photography%20warm%20gentle%20shadows%20luxury%20footwear%20aesthetic%20no%20text%20no%20logos%20clean%20fresh%20look%20European%20style%20high%20detail%20leather%20texture%20minimalist%20setting&width=400&height=500&seq=trust-gallery-loafers-v3&orientation=portrait"
                  alt="Premium suede loafers"
                  className="w-full h-full object-cover object-top"
                  onError={(e) => { (e.target as HTMLImageElement).src = fallbackShoes; }}
                />
              </div>

              <div className="absolute bottom-4 right-4 w-24 h-24 md:w-32 md:h-32 rounded-2xl overflow-hidden bg-background-100 border border-background-200/50 z-20 rotate-[-4deg] shadow-md">
                <img
                  src="https://readdy.ai/api/search-image?query=Luxury%20glass%20perfume%20bottle%20with%20gold%20cap%20on%20cream%20marble%20surface%20soft%20natural%20light%20editorial%20product%20photography%20warm%20gentle%20shadows%20premium%20fragrance%20aesthetic%20no%20text%20no%20logos%20clean%20fresh%20look%20European%20style%20high%20detail%20minimalist%20composition&width=400&height=400&seq=trust-gallery-perfume-v3&orientation=squarish"
                  alt="Luxury perfume"
                  className="w-full h-full object-cover object-top"
                  onError={(e) => { (e.target as HTMLImageElement).src = fallbackPerfume; }}
                />
              </div>
            </div>

            <div className="flex gap-3 overflow-x-auto pb-2 -mx-2 px-2">
              <div className="shrink-0 w-24 md:w-28">
                <div className="w-24 h-24 md:w-28 md:h-28 rounded-xl overflow-hidden bg-background-100 border border-background-200/50">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20straw%20fedora%20hat%20on%20cream%20background%20soft%20natural%20daylight%20editorial%20product%20photography%20warm%20gentle%20shadows%20premium%20fashion%20accessory%20aesthetic%20no%20text%20no%20logos%20clean%20fresh%20look%20European%20style%20minimalist%20setting&width=300&height=300&seq=trust-strip-hat-v3&orientation=squarish"
                    alt="Headwear"
                    className="w-full h-full object-cover object-top"
                    onError={(e) => { (e.target as HTMLImageElement).src = fallbackHat; }}
                  />
                </div>
                <p className="mt-1.5 text-xs text-center text-foreground-500 font-medium">Headwear</p>
              </div>

              <div className="shrink-0 w-24 md:w-28">
                <div className="w-24 h-24 md:w-28 md:h-28 rounded-xl overflow-hidden bg-background-100 border border-background-200/50">
                  <img
                    src="https://readdy.ai/api/search-image?query=Premium%20brown%20leather%20belt%20with%20brass%20buckle%20on%20cream%20background%20soft%20natural%20daylight%20editorial%20product%20photography%20warm%20gentle%20shadows%20luxury%20accessory%20aesthetic%20no%20text%20no%20logos%20clean%20fresh%20look%20European%20style%20minimalist%20setting&width=300&height=300&seq=trust-strip-belt-v3&orientation=squarish"
                    alt="Belts"
                    className="w-full h-full object-cover object-top"
                    onError={(e) => { (e.target as HTMLImageElement).src = fallbackBelt; }}
                  />
                </div>
                <p className="mt-1.5 text-xs text-center text-foreground-500 font-medium">Belts</p>
              </div>

              <div className="shrink-0 w-24 md:w-28">
                <div className="w-24 h-24 md:w-28 md:h-28 rounded-xl overflow-hidden bg-background-100 border border-background-200/50">
                  <img
                    src="https://readdy.ai/api/search-image?query=Minimal%20white%20cotton%20t-shirt%20folded%20on%20cream%20background%20soft%20natural%20daylight%20editorial%20product%20photography%20warm%20gentle%20shadows%20premium%20basics%20aesthetic%20no%20text%20no%20logos%20clean%20fresh%20look%20European%20style%20minimalist%20setting&width=300&height=300&seq=trust-strip-tee-v3&orientation=squarish"
                    alt="T-Shirts"
                    className="w-full h-full object-cover object-top"
                    onError={(e) => { (e.target as HTMLImageElement).src = fallbackTee; }}
                  />
                </div>
                <p className="mt-1.5 text-xs text-center text-foreground-500 font-medium">T-Shirts</p>
              </div>

              <div className="shrink-0 w-24 md:w-28">
                <div className="w-24 h-24 md:w-28 md:h-28 rounded-xl overflow-hidden bg-background-100 border border-background-200/50">
                  <img
                    src="https://readdy.ai/api/search-image?query=Stylish%20canvas%20backpack%20on%20cream%20background%20soft%20natural%20daylight%20editorial%20product%20photography%20warm%20gentle%20shadows%20premium%20travel%20accessory%20aesthetic%20no%20text%20no%20logos%20clean%20fresh%20look%20European%20style%20minimalist%20setting&width=300&height=300&seq=trust-strip-bag-v3&orientation=squarish"
                    alt="Bags"
                    className="w-full h-full object-cover object-top"
                    onError={(e) => { (e.target as HTMLImageElement).src = fallbackBag; }}
                  />
                </div>
                <p className="mt-1.5 text-xs text-center text-foreground-500 font-medium">Bags</p>
              </div>

              <div className="shrink-0 w-24 md:w-28">
                <div className="w-24 h-24 md:w-28 md:h-28 rounded-xl overflow-hidden bg-background-100 border border-background-200/50">
                  <img
                    src="https://readdy.ai/api/search-image?query=Designer%20sunglasses%20with%20gold%20frame%20on%20cream%20marble%20surface%20soft%20natural%20daylight%20editorial%20product%20photography%20warm%20gentle%20shadows%20luxury%20eyewear%20aesthetic%20no%20text%20no%20logos%20clean%20fresh%20look%20European%20style%20minimalist%20composition&width=300&height=300&seq=trust-strip-glasses-v3&orientation=squarish"
                    alt="Accessories"
                    className="w-full h-full object-cover object-top"
                    onError={(e) => { (e.target as HTMLImageElement).src = fallbackGlasses; }}
                  />
                </div>
                <p className="mt-1.5 text-xs text-center text-foreground-500 font-medium">Accessories</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}